<template>
  <div
    @click="handleResourceBlockClick"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    class="col-md-3"
  >
    <div class="card card1 p-3 text-center border-0">
      <p class="black1">
        <img
          :src="imgURL"
          alt="block-resource"
          height="50px;"
          :class="hover ? 'huerotate' : ''"
        />
      </p>
      <p class="">
        {{ name }}
      </p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import config from "@/assets/_config.json";
import ResourceGamePromo from "@/components/blockResources/resourceGamePromo";
import ResourceFlipBook from "@/components/blockResources/resourceFlipBook";
import ResourceRegistration from "@/components/blockResources/resourceRegistration";
import ResourceSurvey from "@/components/blockResources/resourceSurvey";

export default {
  name: "Block",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ResourceGamePromo,
    // eslint-disable-next-line vue/no-unused-components
    ResourceFlipBook,
    // eslint-disable-next-line vue/no-unused-components
    ResourceRegistration,
    // eslint-disable-next-line vue/no-unused-components
    ResourceSurvey
  },
  props: {
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      name: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder",
      hover: false,
      config
    };
  },
  computed: {},
  methods: {
    handleResourceBlockClick() {
      this.$emit("resource-clicked", this.resource);
      /*const instance = this.instantiateComponent(
        this.resource,
        this.publishing
      );

      if (instance) {
        //check if available
        if (instance.hasOwnProperty("showResource")) {
          //console.log('Showing resource');
          instance.showResource();
        }else{
          console.log('not avail');
        }
      }*/
    },
    instantiateComponent(resource, publishing) {
      let instance = null;
      let ComponentClass = null;

      switch (resource.toolId) {
        case "dOfV3PoraqpUUEFiv5R3":
          ComponentClass = Vue.extend(ResourceGamePromo);
          break;
        case "44NJCwDlvhgqnbugSvYT":
          ComponentClass = Vue.extend(ResourceFlipBook);
          break;
        case "6j5w3qeU77vMaTx3op2y":
          ComponentClass = Vue.extend(ResourceRegistration);
          break;
        case "jnYuOcxljbqTdfLLfhRf":
          ComponentClass = Vue.extend(ResourceSurvey);
          break;
        default:
          ComponentClass = Vue.extend(ResourceGamePromo);
          break;
      }

      instance = new ComponentClass({
        propsData: {
          resource: resource,
          publishing: publishing
        }
      });

      if (instance) {
        instance.$mount();
      }
      return instance;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.huerotate {
  -webkit-filter: invert(80%) sepia(85%) saturate(3188%) hue-rotate(330deg)
    brightness(98%) contrast(107%);
  filter: invert(80%) sepia(85%) saturate(3188%) hue-rotate(330deg)
    brightness(98%) contrast(107%);
}

.card {
  background-color: transparent;
  border-radius: 10px;
  padding: 10px;
  display: block;
  cursor: pointer;
}
.card:hover {
  background-color: #222222;
  color: #ffc727;
  padding: 10px;
  fill: #ffc727;
  transform: scale(1.05);
}

.ico-bookmark {
  margin-right: 8px;
  cursor: pointer;
  &:hover {
    transform: scale(1.07);
  }
}
.ico-share {
  cursor: pointer;
  position: relative;
  svg {
    &:hover {
      transform: scale(1.07);
    }
  }
  &:active {
    transform: none;
  }
  .share-popup {
    position: absolute;
    width: 150px;
    height: 45px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    top: 100%;
    left: 80%;
    z-index: 3;
    &:hover {
      transform: none;
    }
  }
}
</style>
